// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ig-0";